// extracted by mini-css-extract-plugin
export var dropdownButton = "_2y-0";
export var fullWidthDropdownButton = "_2y-1";
export var icon = "_2y-3";
export var iconPlaceholder = "_2y-2";
export var menuItemRow = "_2y-9";
export var separator = "_2y-e";
export var shortcutContainer = "_2y-7";
export var shortcutContainerFilled = "_2y-8";
export var shortcutIconLg = "_2y-6";
export var shortcutIconMd = "_2y-5";
export var shortcutIconSm = "_2y-4";
export var submenuChevron = "_2y-d";
export var submenuDropdown = "_2y-a";
export var submenuTriggerRow = "_2y-b";
export var submenuTriggerRowOpen = "_2y-c";